import { render, staticRenderFns } from "./talent3.vue?vue&type=template&id=67ad509c&scoped=true"
import script from "./talent3.vue?vue&type=script&lang=js"
export * from "./talent3.vue?vue&type=script&lang=js"
import style0 from "./talent3.vue?vue&type=style&index=0&id=67ad509c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad509c",
  null
  
)

export default component.exports